import { DivisionBase } from './base/division-base';

export class Division extends DivisionBase { }